import React, { useEffect, useState } from 'react';
import { LoadingButton, SectionTitle, Spinner, Toggle } from 'components';
import I18n from 'i18n-js';
import './fix-perfil-detalles.module.scss';
import SectionWrapper from 'components/SectionWrapper/SectionWrapper';
import MatcherPerfilesConsumoInstance from 'services/remote/MatcherPerfilesConsumoService';
import { toast } from 'react-toastify';
import { Form, Formik } from 'formik';
import { FormGroup, FormGroupProps } from 'core';
import ButtonCsv from 'components/ButtonCsv/ButtonCsv';
import customToast from 'components/CustomToast/CustomToast';
import Button from 'components/Button/Button';
import { navigate } from 'navigation';
import CupsTooltipOferta from 'pages/SignUpPage/components/CupsTooltip/CupsTooltipOferta';
import OnboardingPerfilDeConsumo from 'types/models/onboardingPertfilConsumo';
import OnboardingPerfilDeConsumoInstance from 'services/remote/OnboardingPerfildeConsumo';
import styles from './perfil-detalles.module.scss';

export const OnbardingPerfilDetalle = (props: any): JSX.Element => {
  // Props
  const {
    match: {
      params: { id },
    },
  } = props;
  const [perfilDeConsumo, setPerfilesDeConsumo] = useState<OnboardingPerfilDeConsumo>();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isActive, setIsActive] = useState(false);
  const [mensajeError, setMensajeError] = useState({
    codigo: '',
    mensaje: '',
  });
  const [loadingExport, setLoadingExport] = useState<boolean>(false);
  const [loadingForm, setLoadingForm] = useState<boolean>(false);
  const [input, setInputs] = useState({
    nombre: '',
  });

  const getPerfilesDeConsumoById = async () => {
    setLoading(true);

    try {
      const apiData = await OnboardingPerfilDeConsumoInstance.getPerfilesDeConsumorById(id);
      setInputs({
        nombre: apiData?.perfil_consumidor,
      });
      setPerfilesDeConsumo(apiData);
    } catch (error) {
      toast.error(I18n.t('PerfilListPage.EditPerfilesConsumo_fetching_error'));
    }
    setLoading(false);
  };

  const formGroupUserDataLeft: Array<FormGroupProps> = [
    {
      label: I18n.t('Name'),
      type: 'text',
      id: 'nombre',
      path: 'nombre',
      name: 'nombre',
      value: input.nombre,
      placeholder: I18n.t('Name'),
      tabindex: 1,
      readOnly: true,
      disabled: true, // No se puede editar el nombre del perfil de consumo
    },
  ];

  const handleFileSelect = (file: File) => {
    setSelectedFile(file);
  };

  const submitForm = async (): Promise<void> => {
    setLoadingForm(true);
    if (loadingForm === true) {
      return; // Evitar múltiples envíos del formulario
    }
    try {
      if (selectedFile) {
        // Repasar
        const addCSV = await OnboardingPerfilDeConsumoInstance.patchCsvCurvaDeConsumo(id, selectedFile);
        if (addCSV === 200) {
          customToast.success(I18n.t('PerfilListPage.UpdatePerfilesConsumo_fetching'));
        } else {
          setLoading(false);
          setMensajeError(addCSV);
        }
      } else {
        navigate('/tecnic/onboarding');
      }
    } catch (error) {
      // llamar a MatcherErrorCsvService utils para trata de errores
      toast.error(I18n.t('PerfilListPage.UpdatePerfilesConsumo_fetching_error'));
    } finally {
      setLoadingForm(false);
      setSelectedFile(null);
      getPerfilesDeConsumoById();
    }
  };
  const exportInforme = async (): Promise<void> => {
    setLoadingExport(true);
    try {
      const ejecutarInforme = await MatcherPerfilesConsumoInstance.descargarInforme(Number(id));
      const a = document.createElement('a');
      a.href = `data:text/csv;charset=utf-8,${ejecutarInforme}`;
      a.textContent = 'download';
      a.download = `${new Date().toLocaleDateString()}_ExportData.csv`;
      a.click();
      a.remove();
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingExport(false);
    }
  };
  useEffect(() => {
    getPerfilesDeConsumoById();
  }, [id]);
  return (
    <SectionWrapper>
      {loading ? (
        <div className={styles.loading}>
          <Spinner size={100} icon />
        </div>
      ) : (
        <>
          {perfilDeConsumo !== undefined ? (
            <div className={styles.root}>
              <div className={styles.form}>
                <div className={styles.posotionradio}>
                  <div className={styles.postflex}>
                    <SectionTitle text={I18n.t('PerfilListPage.titleDetalle')} />
                  </div>
                  <div className={styles.positionValidar}>{/* )} */}</div>
                </div>

                <div className={styles.containerForms}>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      nombre: '',
                    }}
                    onSubmit={async (): Promise<void> => {
                      if (loadingExport === true) {
                        await exportInforme();
                      } else {
                        await submitForm();
                      }
                    }}
                  >
                    {() => (
                      <Form className={styles.form}>
                        <div className={styles.margenesInputModal}>
                          {formGroupUserDataLeft.map((formGroup: FormGroupProps) => (
                            <div key={formGroup.id} style={{ width: '100%' }}>
                              <FormGroup
                                key={formGroup.id}
                                label={formGroup.label}
                                type={formGroup.type}
                                id={formGroup.id}
                                path={formGroup.path}
                                name={formGroup.name}
                                placeholder={formGroup.placeholder}
                                value={formGroup.value}
                                options={formGroup.options}
                                disabled={formGroup.disabled}
                                tabindex={formGroup.tabindex}
                                error={formGroup.error}
                                readOnly={formGroup.readOnly}
                              />
                            </div>
                          ))}
                          <div className={styles.margenesInputModal}>
                            {perfilDeConsumo.curva_consumo === false ? (
                              <>
                                <CupsTooltipOferta
                                  title={I18n.t('PerfilListPage.showPerfilConsumoCsv')}
                                  info={I18n.t('TooltipOferta.subtitle')}
                                />

                                <ButtonCsv className={styles.csv_button} onFileSelect={handleFileSelect} />
                                {mensajeError.codigo === '' ? null : (
                                  <div className={styles.errorMessage}>
                                    <p>{I18n.t(mensajeError.codigo)}</p>
                                    <p>{mensajeError.mensaje}</p>
                                  </div>
                                )}
                              </>
                            ) : (
                              <>
                                <div className={styles.toogle_wrapper}>
                                  <p>{I18n.t('PerfilListPage.tituloCurva')}</p>
                                  <Toggle value={isActive} onChange={setIsActive} />
                                </div>
                                <div className={styles.toogle_wrapper} onClick={exportInforme}>
                                  <p className={styles.link_paragraph}>
                                    {I18n.t('PerfilListPage.addMatcher.exportGeneracioDescExist')}
                                  </p>
                                </div>
                                {isActive ? (
                                  <>
                                    <CupsTooltipOferta
                                      title={I18n.t('PerfilListPage.showPerfilConsumoCsv')}
                                      info={I18n.t('TooltipOferta.subtitle')}
                                    />

                                    <ButtonCsv className={styles.csv_button} onFileSelect={handleFileSelect} />
                                    {mensajeError.codigo === '' ? null : (
                                      <div className={styles.errorMessage}>
                                        <p>{I18n.t(mensajeError.codigo)}</p>
                                        <p>{mensajeError.mensaje}</p>
                                      </div>
                                    )}
                                  </>
                                ) : null}
                              </>
                            )}
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>

                <div className={styles.positionBotonoes}>
                  <div className={styles.divBoton}>
                    <Button
                      type="button"
                      onClick={(): Promise<void> => navigate('/tecnic/onboarding')}
                      variant="secondary"
                      text={I18n.t('Cancel')}
                    />
                    <LoadingButton type="submit" text={I18n.t('Save')} onClick={submitForm} loading={loadingForm} />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p>{I18n.t('PerfilListPage.EditPerfilesConsumo_fetching_error')}</p>
          )}
        </>
      )}
    </SectionWrapper>
  );
};
